import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import PageRelatedList from 'Component/PageRelatedList';
import { PageCardPropsType } from 'Type/CMS.type';
import { MixType } from 'Type/Common.type';

import './MyAccountPushPages.style';

/** @namespace PeggysagePwa/Component/MyAccountPushPages/Component */
export class MyAccountPushPagesComponent extends PureComponent {
    static propTypes = {
        items: PropTypes.arrayOf(PageCardPropsType).isRequired,
        mix: MixType.isRequired
    };

    render() {
        const { items, mix } = this.props;

        return (
            <div block="MyAccountPushPages" mix={ mix }>
                <PageRelatedList
                  title={ __('À la une') }
                  pages={ items }
                  isHorizontallyDisplayedOnMobile
                />
            </div>
        );
    }
}

export default MyAccountPushPagesComponent;
